import React from 'react';
import styles from './LetterAvatar.module.sass';

const colors = [
    '#FFD485', // Jaune/Orange clair
     //'#XXXXXX', Tu peux rajouter d'autres couleur
];

const LetterAvatar = ({ firstName, lastName, size = 40 }) => {
    const initials = `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase();
    
    // Générer une couleur basée sur le nom complet (pour avoir toujours la même couleur pour la même personne)
    const fullName = `${firstName} ${lastName}`;
    const colorIndex = Math.abs(fullName.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0)) % colors.length;
    const backgroundColor = colors[colorIndex];

    return (
        <div 
            className={styles.avatar}
            style={{
                backgroundColor,
                width: size,
                height: size,
                fontSize: size * 0.4
            }}
        >
            {initials}
        </div>
    );
};

export default LetterAvatar;
